<p>Subject Dictionary Import</p>
<hr>

<div class="row g-4">
  <div class="col-12">
    <mat-card>
      <mat-card-content>
        <h5 class="mb-3">Upload Subject Dictionary Excel</h5>

        <div class="row g-3">
          <!-- Course Dropdown -->
          <div class="col-12 col-md-6">
            <mat-form-field appearance="fill" class="w-100">
              <mat-label>Select Course</mat-label>
              <mat-select [(ngModel)]="selectedCourseId" name="course" required>
                <mat-option *ngFor="let course of courseList" [value]="course">
                  {{ course.name }}-{{course.crs_code}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="col-12 col-md-6">
               <mat-form-field appearance="outline" class="w-100 mb-3">
        <mat-label>Select Result Type</mat-label>
        <mat-select [(ngModel)]="resultType" name="resultType">
          <mat-option value="regular">Regular</mat-option>
          <mat-option value="iti">ITI</mat-option>
          <mat-option value="puc">PUC</mat-option>
          <mat-option value="COB">COB</mat-option>
        </mat-select>
      </mat-form-field>
          </div>

          <!-- File Upload -->
          <div class="col-12 col-md-6">
            <input type="file" (change)="onFileChange($event)" accept=".xlsx, .xls" />
          </div>

           <div class="col-12"><a href="/assets/subject_dictionary.xls">Download Sample Sheet</a></div>

          <!-- Buttons -->
          <div class="col-12">
            <div class="d-flex gap-3">
              <button mat-flat-button color="primary" (click)="importSubjects()" [disabled]="!excelData || !selectedCourseId">
                Import
              </button>
              <button mat-stroked-button (click)="reset()">Reset</button>
            </div>
          </div>

          <!-- Validation Errors -->
          <div *ngIf="invalidRows.length > 0" class="col-12">
            <mat-card class="mat-elevation-z1 p-2" color="warn">
              <h6>Validation Errors ({{ invalidRows.length }})</h6>
              <ul>
                <li *ngFor="let err of invalidRows">{{ err }}</li>
              </ul>
            </mat-card>
          </div>
        </div>
      </mat-card-content>
    </mat-card>

    <!-- Import Summary -->
<div *ngIf="importSummary" class="col-12">
    <mat-card class="mat-elevation-z1 p-2">
      <h5>Import Summary</h5>
      <p>Total Records: {{ importSummary.total }}</p>
      <p>Inserted: {{ importSummary.inserted }}</p>
      <p>Skipped: {{ importSummary.skipped }}</p>
  
      <div *ngIf="importSkipped.length > 0" class="mt-2">
        <h6>Skipped Rows</h6>
        <table class="table table-bordered table-sm">
          <thead>
            <tr>
              <th>Row</th>
              <th>Sub Code</th>
              <th>Reason</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of importSkipped">
              <td>{{ row.row }}</td>
              <td>{{ row.sub_code }}</td>
              <td>{{ row.reason }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </mat-card>
  </div>
  
  </div>
</div>
